import { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { injectedProvider } from "./wallet-connector";
import layer6 from "../images/layer6.png";
import cityFountain from "../images/fountain.png";
import layer from "./layer.svg";
import calculator_ from "./calculator_.svg";
import calculator from "./calculator.svg";
import heart from "./heart.svg";
import wallpaper from "./wallpaper.svg";
import book from "./book.svg";
import lock from "./lock.svg";
import achieve from "./achieve.svg";
import wallet from "./wallet.svg";
import add from "./add.svg";
import user from "./user.svg";
import lock_ from "./lock_.svg";
import bubbler from "../abi/bubbler.json";
import fountain from "../abi/fountain.json";
import rez from "../abi/rez.json";
import WOW from 'wowjs';
import { useEffect } from "react";
import { useRef } from "react";
import Jazzicon from "@metamask/jazzicon";
import styled from "@emotion/styled";
import { useWeb3React } from "@web3-react/core";

const Fountain = (passweb) => {

  var {
    account,
    activate,
    active,
    chainId,
    connector,
    deactivate,
    error,
    provider,
    setError
    } = useWeb3React();

  const [pRewards, setPRewards] = useState("");
  const [TLP, setTLP] = useState("");
  const [stake, setStake] = useState("");
  const [etherBalance, setEtherBalance] = useState("");
  const [resp_, setResp_] = useState("");
  const [eBalance0_, setEth_balance] = useState("");
  const [resp_raw, setResp_raw] = useState("");
  const [eBalance0_raw, setEth_balance_raw] = useState("");
  const [ER, setER] = useState("");
  const [compounds, setCompounds] = useState("");
  const [TW, setTW] = useState("");
  const [CT, setCT] = useState("");
  const [price, setPrice] = useState("");
  const [lpBalance,setLpBalance] = useState("");

  const [players, setPlayers] = useState("");
  const [tvl, setTVL] = useState("");
  const [rewards, setRewards] = useState("");
  const [DP, setDP] = useState("");
  const [CB, setCB] = useState("");
  const [txs, setTxs] = useState("");
  const [teamCount, setTeamCount] = useState(0);
  const [teamArrayy, setTeamArrayy] = useState([]);
  const [myBuddy, setMyBuddy] = useState("");
  const [claimsAvailable_, setClaimsAvailable_] = useState("");


  useEffect(() => {

    document.getElementsByClassName("bg-video")[0].style.display="none";
    document.getElementsByClassName("sectionn")[0].style.display="none";

    new WOW.WOW({
      live: true
    }).init();

     if (typeof window.ethereum !== 'undefined') {
          console.log('MetaMask is installed!');
          getData();  
              }
      else {}



    
   }, []);

  window.onload = ()=>{
    
  }


 const handleConnect = async () => {
      if (typeof window.ethereum !== 'undefined') {
          console.log('MetaMask is installed!');
          await activate(injectedProvider);
          let { provider } = await injectedProvider.activate();
          let web3 = new passweb.webtype(provider); 
          if(typeof window.ethereum!=='undefined' && active) {document.getElementsByClassName("wallet-button")[0].className += " format";}
          document.getElementsByClassName("jazzicon")[0].className += " jazziconn";
          if(window.ethereum.networkVersion!=5) {
              alert("connect to Goerli Testnet");
        }

      }

      else alert("install MetaMask");
    
  }


 const [amount, setAmount] = useState("");

 const buyy = async () => {
  let { provider } = await injectedProvider.activate();
  let web3 = new passweb.webtype(provider);
  const WF_CONTRACT = await new web3.eth.Contract(rez, "0x35cf683766640A0a99Ef6501e23172288aca2564");
  const accounts = await web3.eth.getAccounts();
  let buyAmount = document.getElementById("af-bt").value;
  //buyAmount = web3.utils.toWei(buyAmount.toString());
  	document.getElementById("div1").style.opacity= "1";
    const resp = await WF_CONTRACT.methods.buy().send({
            from: accounts[0],
            gas: '900000',
            value: buyAmount
             }).then(() => {
            alert("good to go");
            getData();
            document.getElementById("div1").style.opacity= "0";
         }).catch((err) => {
            console.log(err);
            document.getElementById("div1").style.opacity= "0";
         });      

    }

  const selll = async () => {
  let { provider } = await injectedProvider.activate();
  let web3 = new passweb.webtype(provider);
  const WF_CONTRACT = await new web3.eth.Contract(rez, "0x35cf683766640A0a99Ef6501e23172288aca2564");
  const accounts = await web3.eth.getAccounts();
  let buyAmount = lpBalance;
  //buyAmount = web3.utils.toWei(buyAmount.toString());
    document.getElementById("div1").style.opacity= "1";
    const resp = await WF_CONTRACT.methods.sell(buyAmount).send({
            from: accounts[0],
            gas: '900000'
             }).then(() => {
            alert("good to go");
            getData();
            document.getElementById("div1").style.opacity= "0";
         }).catch((err) => {
            console.log(err);
            document.getElementById("div1").style.opacity= "0";
         });      

    }


  const withdraww = async () => {
  let { provider } = await injectedProvider.activate();
  let web3 = new passweb.webtype(provider);
  const WF_CONTRACT = await new web3.eth.Contract(rez, "0x35cf683766640A0a99Ef6501e23172288aca2564");
  const accounts = await web3.eth.getAccounts();
  //let dummyString = document.getElementById("af-wt").value;
  //let withdrawAmount = dummyString.replace(".",'');
  //console.log(withdrawAmount);
  	document.getElementById("div1").style.opacity= "1";
    const resp = await WF_CONTRACT.methods.withdraw().send({
            from: accounts[0],
            gas: '900000'
             }).then(() => {
            alert("good to go");
            getData();
            document.getElementById("div1").style.opacity= "0";
         }).catch((err) => {
            console.log(err);
            document.getElementById("div1").style.opacity= "0";
         });      

    }

    const compound = async () => {
  let { provider } = await injectedProvider.activate();
  let web3 = new passweb.webtype(provider);
  const WF_CONTRACT = await new web3.eth.Contract(rez, "0x35cf683766640A0a99Ef6501e23172288aca2564");
  const accounts = await web3.eth.getAccounts();
    document.getElementById("div1").style.opacity= "1";
    const resp = await WF_CONTRACT.methods.reinvest().send({
            from: accounts[0],
            gas: '900000'
             }).then(() => {
            alert("good to go");
            getData();
            document.getElementById("div1").style.opacity= "0";
         }).catch((err) => {
            console.log(err);
            document.getElementById("div1").style.opacity= "0";
         });      

    }

  

  const getData = async () => {
      let { provider } = await injectedProvider.activate();
      let web3 = new passweb.webtype(provider);
      const EARTH_CONTRACT = await new web3.eth.Contract(bubbler,"0x3fce1Fc6369C93BbB91BA00bD51dE3De2A5E085A");
      
      const WF_CONTRACT = await new web3.eth.Contract(rez, "0x35cf683766640A0a99Ef6501e23172288aca2564");
      const WF0_CONTRACT = await new web3.eth.Contract(fountain, "0xd0866F3A3Bc1C455f5FCD97fca0B316D1f0C694e");
      //var resp0 = await WF_CONTRACT.methods.getTokenToBnbInputPrice("1000000000000000000").call();
      //resp0 = resp0/1000000000000000000;
      //setPrice(resp0.toFixed(6));
      const accounts = await web3.eth.getAccounts();
      const resp = await WF_CONTRACT.methods.statsOf(accounts[0]).call();
      //const r1 = await WF_CONTRACT.methods.statsOf(accounts[0]).call();
      const r2 = await WF_CONTRACT.methods.totalTokenBalance().call();
      const r3 = await WF_CONTRACT.methods.totalClaims().call();
      const r4 = await WF_CONTRACT.methods.dividendBalance().call();
      const r5 = await WF_CONTRACT.methods.totalTxs().call();
      const r6 = await WF_CONTRACT.methods.players().call();
      let resp0 = await WF_CONTRACT.methods.balanceOf(accounts[0]).call();
      let resp2 = await WF0_CONTRACT.methods.balanceOf("0x35cf683766640A0a99Ef6501e23172288aca2564").call();
      let resp3 = await WF0_CONTRACT.methods.balanceOf(accounts[0]).call();
      //const maxPayout = await PROXY_CONTRACT.methods.maxPayoutOf(resp.deposits).call();
      let eBalance = await web3.eth.getBalance(accounts[0]);
      let eBalance0=parseInt(eBalance)/1e18;
      //setResp_raw(resp2);
      setEth_balance_raw(parseInt(eBalance))
      setEth_balance(eBalance0);
      //setResp_(parseInt(resp2));
      eBalance0 = eBalance0.toFixed(5);
      setEtherBalance(eBalance0);
      setLpBalance(resp0);
      setPRewards(resp[2]);
      setTLP((resp[4]/10e17).toFixed(2));
      setStake(resp[0]);
      setCompounds(resp[14]);
      setTW(resp[1]);
      setCT((resp[13]/10e17).toFixed(2));
      setCB((resp2/10e17).toFixed(2));
      setTxs(r5);
      setDP((r4/10e17).toFixed(6));
      setTLP((resp3/10e17).toFixed(2))
      setRewards(r3);
      setTVL((r2/10e17).toFixed(2));
      setPlayers(r6);

  }

  const GetLPMax = async () => {
      document.getElementById("af-wt").value = lpBalance/1e18;
  }

  const GetEarthMax = async () => {
      //document.getElementById("af-st").value = resp_/10e17;
  }

  const getER = async () => {
  	/*let { provider } = await injectedProvider.activate();
  let web3 = new passweb.webtype(provider);
  const WF_CONTRACT = await new web3.eth.Contract([{"inputs":[{"internalType":"address","name":"token_addr","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Mint","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"addr","type":"address"}],"name":"WhitelistedAddressAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"addr","type":"address"}],"name":"WhitelistedAddressRemoved","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"provider","type":"address"},{"indexed":true,"internalType":"uint256","name":"bnb_amount","type":"uint256"},{"indexed":true,"internalType":"uint256","name":"token_amount","type":"uint256"}],"name":"onAddLiquidity","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"buyer","type":"address"},{"indexed":true,"internalType":"uint256","name":"token_amount","type":"uint256"},{"indexed":true,"internalType":"uint256","name":"bnb_amount","type":"uint256"}],"name":"onBnbPurchase","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"balance","type":"uint256"}],"name":"onContractBalance","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"provider","type":"address"},{"indexed":true,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"onLiquidity","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"price","type":"uint256"}],"name":"onPrice","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"provider","type":"address"},{"indexed":true,"internalType":"uint256","name":"bnb_amount","type":"uint256"},{"indexed":true,"internalType":"uint256","name":"token_amount","type":"uint256"}],"name":"onRemoveLiquidity","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"liquidity","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"price","type":"uint256"}],"name":"onSummary","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"buyer","type":"address"},{"indexed":true,"internalType":"uint256","name":"bnb_amount","type":"uint256"},{"indexed":true,"internalType":"uint256","name":"token_amount","type":"uint256"}],"name":"onTokenPurchase","type":"event"},{"inputs":[{"internalType":"address","name":"addr","type":"address"}],"name":"addAddressToWhitelist","outputs":[{"internalType":"bool","name":"success","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address[]","name":"addrs","type":"address[]"}],"name":"addAddressesToWhitelist","outputs":[{"internalType":"bool","name":"success","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"min_liquidity","type":"uint256"},{"internalType":"uint256","name":"max_tokens","type":"uint256"}],"name":"addLiquidity","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"bnbBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"min_tokens","type":"uint256"}],"name":"bnbToTokenSwapInput","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokens_bought","type":"uint256"}],"name":"bnbToTokenSwapOutput","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"bnb_sold","type":"uint256"}],"name":"getBnbToLiquidityInputPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"bnb_sold","type":"uint256"}],"name":"getBnbToTokenInputPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokens_bought","type":"uint256"}],"name":"getBnbToTokenOutputPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"input_amount","type":"uint256"},{"internalType":"uint256","name":"input_reserve","type":"uint256"},{"internalType":"uint256","name":"output_reserve","type":"uint256"}],"name":"getInputPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getLiquidityToReserveInputPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"output_amount","type":"uint256"},{"internalType":"uint256","name":"input_reserve","type":"uint256"},{"internalType":"uint256","name":"output_reserve","type":"uint256"}],"name":"getOutputPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokens_sold","type":"uint256"}],"name":"getTokenToBnbInputPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"bnb_bought","type":"uint256"}],"name":"getTokenToBnbOutputPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"isPaused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"providers","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"addr","type":"address"}],"name":"removeAddressFromWhitelist","outputs":[{"internalType":"bool","name":"success","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address[]","name":"addrs","type":"address[]"}],"name":"removeAddressesFromWhitelist","outputs":[{"internalType":"bool","name":"success","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"min_bnb","type":"uint256"},{"internalType":"uint256","name":"min_tokens","type":"uint256"}],"name":"removeLiquidity","outputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"tokenAddress","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"tokenBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokens_sold","type":"uint256"},{"internalType":"uint256","name":"min_bnb","type":"uint256"}],"name":"tokenToBnbSwapInput","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"bnb_bought","type":"uint256"},{"internalType":"uint256","name":"max_tokens","type":"uint256"}],"name":"tokenToBnbSwapOutput","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalTxs","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"txs","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"unpause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"whitelist","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"stateMutability":"payable","type":"receive"}], "0xFe9eF6EbE192E91c01212E26cb9c279Cddf25b25");
  const accounts = await web3.eth.getAccounts();
  if(document.getElementById("af-bt").value==0){setER(0); setMR(0);}
  const resp = await WF_CONTRACT.methods. getBnbToTokenInputPrice(document.getElementById("af-bt").value).call();
  setER(resp);
  //TAX
  const resp2 = resp-(resp*(5/100));
  setMR(resp2);
  document.getElementById("lite").style.color="white";
    document.getElementById("lite2").style.color="white"; */
  }


  const Approve_sell_contract = async () => {
  		let { provider } = await injectedProvider.activate();
  		let web3 = new passweb.webtype(provider);
  		const EARTH_CONTRACT = await new web3.eth.Contract(bubbler,"0x3fce1Fc6369C93BbB91BA00bD51dE3De2A5E085A");
		const accounts = await web3.eth.getAccounts();
		document.getElementById("div1").style.opacity= "1";
    	const resp = await EARTH_CONTRACT.methods.approve("0xd0866F3A3Bc1C455f5FCD97fca0B316D1f0C694e","1000000000000000000000000000000000").send({
            from: accounts[0],
            gas: '900000'
             }).then(() => {
            alert("good to go");
            document.getElementById("div1").style.opacity= "0";
         }).catch((err) => {
            console.log(err);
            document.getElementById("div1").style.opacity= "0";
         });      	


  }


  return (
    <div>
        <div className="background-paper"><img src={wallpaper}></img></div>

        <div>
            <ul className="settings-list">
            <li><img src={layer}></img> Buy and deposit <input type="text" className="settings-buy" onChange={getER}/> <button className="set-buy" onClick={buyy}>buy</button></li>
            <li><img src={calculator_}></img>Sell <input type="text" className="settings-withdraw"/>
                <button className="maxx" onClick={GetLPMax}>Max </button><button className="set-sell" onClick={selll}>Sell LP token</button></li>
            <li><img src={heart}></img>Rewards   <span>{active?pRewards : "0.000"} <button className="set-sell" onClick={withdraww}>Claim</button></span></li>
            <li><img src={wallpaper}></img>LP Token   <span>{active?TLP : "0.000"}</span></li>
            <li><img src={book}></img>Stake   <span>{active? (stake/10e17).toFixed(2) : "0.000"}</span></li>
            <li><img src={lock}></img>Compounds   <span>{active? compounds : "0.000"} <button className="set-sell" onClick={compound}>Compound</button></span></li>
            <li><img src={wallet}></img>Total withdrawn   <span>{active? TW : "0.000"}</span></li>
            <li><img src={add}></img>Compounded total   <span>{active? CT : "0"}</span></li>
          </ul>
        </div>

        <div>
            <ul className="settings-list2">
            <li><img src={layer}></img> Buy and deposit <input type="text" className="settings-buy" id="af-bt" onChange={getER} placeholder="PLS"/> <button className="set-buy" onClick={buyy}>buy</button></li>
            <li><img src={calculator_}></img>Sell <input type="text" className="settings-withdraw" id="af-wt" placeholder="LP Amount"/>
                <button className="maxx" onClick={GetLPMax}>Max </button><button className="set-sell" onClick={selll}>Sell LP token</button></li>
            <li><img src={heart}></img>Rewards   <span>{active?pRewards : "0.000"} <button className="set-sell" onClick={withdraww}>Claim</button></span></li>
            <li><img src={wallpaper}></img>LP Token   <span>{active?TLP : "0.000"}</span></li>
            <li><img src={book}></img>Stake   <span>{active? (stake/10e17).toFixed(2) : "0.000"}</span></li>
            <li><img src={lock}></img>Compounds   <span>{active? compounds : "0.000"} <button className="set-sell" onClick={compound}>Compound</button></span></li>
            <li><img src={wallet}></img>Total withdrawn   <span>{active? TW : "0.000"}</span></li>
            <li><img src={add}></img>Compounded total   <span>{active? CT : "0"}</span></li>
          </ul>
        </div>

        <div>
            <ul className="settings-list4">
            <li><img src={user}></img>players count  {active?players : "♢"}</li>
            <li><img src={lock_}></img>Total value locked  {active?tvl : "♢"}</li>
            <li><img src={heart}></img>Rewards  {active?rewards : "♢"}</li>
            <li><img src={wallpaper}></img>Dividend pool  {active? DP : "♢"} LP token (locked)</li>
            <li><img src={calculator}></img>Contract balance   {active? CB : '♢'} LP token</li>
            <li><img src={lock}></img>Transactions count  {active? txs : "♢"}</li>
          </ul>
        </div>

        <div>
            <ul className="settings-list4">
            <li><img src={user}></img>players count  {active?players : "♢"}</li>
            <li><img src={lock_}></img>Total value locked  {active?tvl : "♢"}</li>
            <li><img src={heart}></img>Rewards  {active?rewards : "♢"}</li>
            <li><img src={wallpaper}></img>Dividend pool  {active? DP : "♢"} LP token (locked)</li>
            <li><img src={calculator}></img>Contract balance   {active? CB : '♢'} LP token</li>
            <li><img src={lock}></img>Transactions count  {active? txs : "♢"}</li>
          </ul>
        </div>



      </div>);
	};

export default Fountain;